import { acalarmTypes } from '../acReduxExports';

const alarmsInitialState: AcAlarmsState = {
  alarms: null,
  alarmEvents:null,
  alarmEventsCount:0,
  alarmDashboardCount: null,
  alarmEventCount:null,
  alarmsCount: 0,
  alarmHistoryTableProps: {
    sortBy: 'alarmSetTime',
    order: 'descending',
    pageSize: 15,
    pageNumber: 1,
    searchTerm: null
  },
  activeAlarmTableProps: {
    view: 'list',
    sortBy: 'severity',
    order: 'ascending',
    pageSize: 15,
    pageNumber: 1,
    searchTerm: null
  },
  alarmFiltersAppliedFromRedirection: false,
  pulseAlarmLoader: false,
  alarmListRequestSearchHash: null,
  alarmListRequestFilterHash: null,
  alarmListCardsRequestSearchHash: null,
  alarmListCardsRequestFilterHash: null,
  alarmTableListLoader: false
};

const acalarmsReducer = (
  state: AcAlarmsState = alarmsInitialState,
  action: AcAlarmsAction
): AcAlarmsState => {
  switch (action.type) {
    case acalarmTypes.FETCH_AC_ALARM_DATA:
      return {
        ...state,
        alarms: action.alarms,
        alarmsCount: action.alarmsCount
      };
      case acalarmTypes.FETCH_AC_ALARM_EVENT_DATA:
      return {
        ...state,
        alarmEvents: action.alarmEvents,
        alarmEventsCount: action.alarmEventsCount
      };
    case acalarmTypes.SET_AC_ALARM_LIST_REQUEST_HASH:
      return {
        ...state,
        alarmListRequestSearchHash: action.alarmListRequestSearchHash,
        alarmListRequestFilterHash: action.alarmListRequestFilterHash
      };
    case acalarmTypes.SET_AC_ALARM_LIST_CARDS_REQUEST_HASH:
      return {
        ...state,
        alarmListCardsRequestSearchHash: action.alarmListCardsRequestSearchHash,
        alarmListCardsRequestFilterHash: action.alarmListCardsRequestFilterHash
      };
    case acalarmTypes.EXPORT_AC_ALARM_DATA:
      return {
        ...state,
      };
    case acalarmTypes.FETCH_AC_ALARM_COUNT_DATA:
      return {
        ...state,
        alarmDashboardCount: action?.alarmDashboardCount,
      };
    case acalarmTypes.SET_AC_ALARM_HISTORY_TABLE_PROPS:
      return {
        ...state,
        alarmHistoryTableProps: action?.alarmHistoryTableProps,
      };
    case acalarmTypes.SET_ACTIVE_AC_ALARM_TABLE_PROPS:
      return {
        ...state,
        activeAlarmTableProps: action?.activeAlarmTableProps,
      };
    case acalarmTypes.CLEAR_AC_ALARM_DATA:
      return {
        ...state,
        // alarms: null,
        // alarmDashboardCount: null,
        // alarmsCount: 0,
        alarmHistoryTableProps: {
          sortBy: state.alarmHistoryTableProps?.sortBy || 'alarmSetTime',
          order: state.alarmHistoryTableProps?.order || 'descending',
          pageSize: state.alarmHistoryTableProps?.pageSize || 15,
          pageNumber: state.alarmHistoryTableProps?.pageNumber || 1,
          searchTerm: null,
        },
        activeAlarmTableProps: {
          view: 'list',
          sortBy: state.activeAlarmTableProps?.sortBy || 'severity',
          order: state.activeAlarmTableProps?.order || 'ascending',
          pageSize: state.activeAlarmTableProps?.pageSize || 15,
          pageNumber: state.activeAlarmTableProps?.pageNumber || 1,
          searchTerm: null,
        },
      };
    case acalarmTypes.SET_AC_FILTERS_APPLIED_FROM_REDIRECTION:
      return {
        ...state,
        alarmFiltersAppliedFromRedirection:
          action.alarmFiltersAppliedFromRedirection,
      };
    case acalarmTypes.SET_PULSE_AC_ALARM_LOADER:
      return {
        ...state,
        pulseAlarmLoader: action.pulseAlarmLoader
      }
      case acalarmTypes.SET_PULSE_AC_ALARM_LIST_LOADER:
        return {
          ...state,
          alarmTableListLoader: action.alarmTableListLoader
        }
    case acalarmTypes.FETCH_AC_ALARM_EVENT_COUNT_DATA:
        return{
          ...state,
          alarmEventCount:action.alarmEventCount
        }
    default:
      return state;
  }
};

export default acalarmsReducer;
